import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-leads-view';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { KanbanAddEditSwimLaneComponent } from '../kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'anterasoftware-kanban-leads-view-container',
  templateUrl: './kanban-leads-view-container.component.html',
  styleUrls: ['./kanban-leads-view-container.component.scss']
})
export class KanbanLeadsViewContainerComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public statusList: any[] = [];
  @Output() public onDropJob: EventEmitter<any> = new EventEmitter();
  @Output() public editCard: EventEmitter<any> = new EventEmitter();
  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onPin: EventEmitter<any> = new EventEmitter();
  @Output() public onSwimLaneChange: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteSwimLane: EventEmitter<any> = new EventEmitter();
  @Output() public onEditLead: EventEmitter<any> = new EventEmitter();
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  public colorWarn = 'warn';
  public modeWarn = 'determinate';
  public valueWarn = 65;
  public bufferValueWarn = 85;
  public color = 'success';
  public mode = 'determinate';
  public value = 50;
  public bufferValue = 75;
  @Input() public defaultImg: string = '';
  constructor(private dialog: MatDialog) { 
  }

  ngOnInit(): void {
  }

  drop(event:any,swimLane:KanbanViewListI) {
    if(event && event.value) {
      let job = {
        lead: event.value,
        status: swimLane,
      }
      this.onDropJob.emit(job);
    }   
  }

  editCardDetails(lead: any) {
    this.onEditLead.emit(lead);
  }

  public cardValueChange(card: KanbanViewCardI, swimLaneIndex: number, cardIndex: number){
    this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    this.selectClicked.emit(this.swimLaneList);
  }

  pinned(cardDetails: any) {
    this.onPin.emit(cardDetails);
  }

  public openSwimLaneDialog(panel?: KanbanViewListI) {
    let dialogRef = this.dialog.open(KanbanAddEditSwimLaneComponent, {
      width: '500px',
      height: '450px',
      panelClass: 'antera-details-dialog',
      data: {
        panel: panel,
        swimlaneLength: this.swimLaneList.length
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {
      let data = {
        formValues: formValues,
        swimlane: panel
      }
      if (formValues) {
        this.onSwimLaneChange.emit(data);
      }
    });
  }

  public deleteSwimLane(swimlane?: KanbanViewListI) {
    this.onDeleteSwimLane.emit(swimlane);
  }

  public onToggleAll(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  }
}
